/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { StationConfigUpdateMutationRequest, StationConfigUpdateMutationResponse, StationConfigUpdatePathParams } from "../models/StationConfigUpdate";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { stationConfigUpdate } from "../axios/stationConfigUpdate";
import { useMutation } from "@tanstack/react-query";

export const stationConfigUpdateMutationKey = () => ["content-ai-api", { url: '/station-config/:stationId' }] as const

export type StationConfigUpdateMutationKey = ReturnType<typeof stationConfigUpdateMutationKey>

/**
 * @summary Update station config
 * {@link /station-config/:stationId}
 */
export function useStationConfigUpdate<TContext>(options: 
{
  mutation?: UseMutationOptions<StationConfigUpdateMutationResponse, ResponseErrorConfig<Error>, {stationId: StationConfigUpdatePathParams["stationId"], data: StationConfigUpdateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<StationConfigUpdateMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? stationConfigUpdateMutationKey()

  return useMutation<StationConfigUpdateMutationResponse, ResponseErrorConfig<Error>, {stationId: StationConfigUpdatePathParams["stationId"], data: StationConfigUpdateMutationRequest}, TContext>({
    mutationFn: async({ stationId, data }) => {
      return stationConfigUpdate(stationId, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}